module.exports = __webpack_public_path__ + "media/images/ico-save-0b17e4f7.svg";